<template>
  <div class="position-wrap mt8">
    <div class="content-item mb8 verticallyCenter align-style-wrap">
      <div class="align-style-ul">
        <el-tooltip
          v-for="(site, index) in defaultSite"
          :key="index"
          :class="getSelected(site)"
          @click.native="changeQuickSite(site)"
          :open-delay="1000"
          effect="dark"
          :content="site.label"
          placement="top"
        >
          <div>
            <div class="inner"></div>
          </div>
        </el-tooltip>
      </div>
    </div>
    <div class="flex1">
      <svg width="140" height="80" viewBox="0 0 140 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          @click.stop="changeSite('leftVal', 3, 60)"
          d="M0 3.99981V75.9998C0 77.2898 0.610617 78.4371 1.55858 79.1686L40 50V30L1.55858 0.831055C0.610618 1.56251 0 2.70985 0 3.99981Z"
          fill="#EAEAEA"
        />
        <text class="svg-text" :x="leftPosition[0]" :y="leftPosition[1]" fill="rgba(0, 0, 0, 0.8)">
          {{ offsetVal[3] == 0 ? "自动" : offsetVal[3] }}
        </text>
        <path
          @click.stop="changeSite('rightVal', 1, 60)"
          d="M140 75.9998V3.99981C140 2.70985 139.389 1.56251 138.441 0.831055L100 30V50L138.441 79.1686C139.389 78.4371 140 77.2898 140 75.9998Z"
          fill="#EAEAEA"
        />
        <text class="svg-text" :x="rightPosition[0]" :y="rightPosition[1]" fill="rgba(0, 0, 0, 0.8)">
          {{ offsetVal[1] == 0 ? "自动" : offsetVal[1] }}
        </text>
        <path
          @click.stop="changeSite('topVal', 0, 30)"
          d="M138.441 0.831055L100 30H40L1.55859 0.831055C2.23413 0.30957 3.08081 0 4 0H136C136.919 0 137.766 0.30957 138.441 0.831055Z"
          fill="#F0F0F0"
        />
        <text class="svg-text" :x="topPosition[0]" :y="topPosition[1]" fill="rgba(0, 0, 0, 0.8)">
          {{ offsetVal[0] == 0 ? "自动" : offsetVal[0] }}
        </text>
        <path
          @click.stop="changeSite('bottomVal', 2, 60)"
          d="M4 80H136C136.919 80 137.766 79.6904 138.441 79.1689L100 50H40L1.55859 79.1689C2.23413 79.6904 3.08081 80 4 80Z"
          fill="#F0F0F0"
        />
        <text class="svg-text" :x="bottomPosition[0]" :y="bottomPosition[1]" fill="rgba(0, 0, 0, 0.8)">
          {{ offsetVal[2] == 0 ? "自动" : offsetVal[2] }}
        </text>
      </svg>
    </div>
    <div class="site-settings" v-show="showSiteSetting" :style="'margin-top:' + marginTop" @click.stop @mousedown.stop>
      <slider-and-input class="mb6" :value.sync="inputNum" :sliderMax="500" titlePosition="allInOneLine" suffix="px" />
      <div class="verticallyCenter site-selects">
        <div class="flex1 verticallyCenter site-nums">
          <div class="site-select" v-for="item in defaultPos" @click="changeSiteNum(item)">{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "rect-position-set",
  data() {
    return {
      inputNum: 0,
      marginTop: 0,
      showSiteSetting: false,
      activeDirection: "",
      activeDirectionIndex: undefined,
      defaultPos: [0, 10, 20, 40, 50, 60, 80, 100],
      defaultSite: [
        {
          label: "顶部居左",
          top: "0%",
          left: "0%",
          rectTop: 0,
          rectLeft: 0,
          rectMargin: [0, 0, 0, 0]
        },
        {
          label: "顶部居中",
          top: "0%",
          left: "50%",
          translate: "(-50%,0)",
          rectTop: 0,
          rectLeft: 50,
          rectMargin: [0, 0, 0, "-50%"]
        },
        {
          label: "顶部居右",
          top: "0%",
          right: "0%",
          rectTop: 0,
          rectLeft: 100,
          rectMargin: [0, 0, 0, "-100%"]
        },
        {
          label: "左侧居中",
          left: "0%",
          top: "50%",
          translate: "(0,-50%)",
          rectTop: 50,
          rectLeft: 0,
          rectMargin: ["-50%", 0, 0, 0]
        },
        {
          label: "中心",
          left: "50%",
          top: "50%",
          translate: "(-50%,-50%)",
          rectTop: 50,
          rectLeft: 50,
          rectMargin: ["-50%", 0, 0, "-50%"]
        },
        {
          label: "右侧居中",
          top: "50%",
          right: "0%",
          translate: "(0,-50%)",
          rectTop: 50,
          rectLeft: 100,
          rectMargin: ["-50%", 0, 0, "-100%"]
        },
        {
          label: "底部居左",
          left: "0%",
          bottom: "0%",
          rectTop: 100,
          rectLeft: 0,
          rectMargin: ["-100%", 0, 0, 0]
        },
        {
          label: "底部居中",
          left: "50%",
          bottom: "0%",
          translate: "(-50%,0)",
          rectTop: 100,
          rectLeft: 50,
          rectMargin: ["-100%", 0, 0, "-50%"]
        },
        {
          label: "底部居右",
          bottom: "0%",
          right: "0%",
          rectTop: 100,
          rectLeft: 100,
          rectMargin: ["-100%", 0, 0, "-100%"]
        }
      ]
    }
  },
  props: {
    left: {
      type: [String, Number]
    },
    top: {
      type: [String, Number]
    },
    margin: {
      type: null
    },
    offset: {
      type: null
    },
    leftType: {
      type: null
    },
    topType: {
      type: null
    }
  },
  watch: {
    ids:{
      handler(newVal,oldVal){
         this.showSiteSetting = false
      },
      deep:true
    },
    inputNum(newVal, oldVal) {
      if (newVal == oldVal) {
        return
      }
      this.offsetVal[this.activeDirectionIndex] = newVal
      let newOffset = [...this.offsetVal]
      newOffset[this.activeDirectionIndex] = newVal
      switch (this.activeDirection) {
        case "leftVal":
          this.$set(newOffset, 1, 0)
          break
        case "rightVal":
          this.$set(newOffset, 3, 0)
          break
        case "topVal":
          this.$set(newOffset, 2, 0)
          break
        case "bottomVal":
          this.$set(newOffset, 0, 0)
          break
      }
      this.offsetVal = newOffset
    }
  },
  computed: {
    ids(){
      return this.$store.state.states.activeID
    },
    getSelected() {
      return function (site) {
        if (
          this.top == parseFloat(site.rectTop) &&
          this.left == parseFloat(site.rectLeft) &&
          this.leftType === "%" &&
          this.topType === "%"
        ) {
          return "selected item"
        }
        return "item"
      }
    },
    leftVal: {
      get() {
        return this.left
      },
      set(newVal) {
        this.$emit("update:left", newVal)
      }
    },
    topVal: {
      get() {
        return this.top
      },
      set(newVal) {
        this.$emit("update:top", newVal)
      }
    },
    marginVal: {
      get() {
        return this.margin || ["auto", "auto", "auto", "auto"]
      },
      set(newVal) {
        this.$emit("update:margin", newVal)
      }
    },
    offsetVal: {
      get() {
        return this.offset || [0, 0, 0, 0]
      },
      set(newVal) {
        this.$emit("update:offset", newVal)
      }
    },
    topPosition() {
      const text = this.offsetVal[0] == 0 ? "自动" : this.offsetVal[0]
      const [w, h] = this.getWidth(text)
      return [70 - parseInt(w / 2), 15 + parseInt(h / 2)]
    },
    rightPosition() {
      const text = this.offsetVal[1] == 0 ? "自动" : this.offsetVal[1]
      const [w, h] = this.getWidth(text)
      return [100 + parseInt((40 - w) / 2), 40 + parseInt(h / 2)]
    },
    bottomPosition() {
      const text = this.offsetVal[2] == 0 ? "自动" : this.offsetVal[2]
      const [w, h] = this.getWidth(text)
      return [70 - parseInt(w / 2), 65 + parseInt(h / 2)]
    },
    leftPosition() {
      const text = this.offsetVal[3] == 0 ? "自动" : this.offsetVal[3]
      const [w, h] = this.getWidth(text)
      return [parseInt((40 - w) / 2), 40 + parseInt(h / 2)]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.closeDialog()
    })
  },
  beforeDestroy() {
    document.getElementsByClassName("right-toolbar")[0]?.removeEventListener("click", this.closeSiteSetting)
    document.getElementsByClassName("edit_stage")[0]?.removeEventListener("click", this.closeSiteSetting)
  },
  methods: {
    // 选择快捷位置
    changeQuickSite(site) {
      this.getWidth("自动")
      this.leftVal = site.rectLeft
      this.topVal = site.rectTop
      this.marginVal = site.rectMargin
      this.offsetVal = [0, 0, 0, 0]
    },
    changeSite(name, index, marginTop) {
      this.inputNum = this.offsetVal[index]
      this.activeDirectionIndex = index
      this.marginTop = marginTop + "px"
      this.showSiteSetting = true
      this.activeDirection = name
    },
    changeSiteNum(val) {
      this.inputNum = val
    },
    // 点击其他区域 关闭弹框
    closeDialog() {
      document.getElementsByClassName("right-toolbar")[0]?.addEventListener("click", this.closeSiteSetting)
      document.getElementsByClassName("edit_stage")[0]?.addEventListener("click", this.closeSiteSetting)
    },
    closeSiteSetting() {
      this.showSiteSetting = false
    },
    getWidth(txt, style = {}) {
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")
      const { fontFamily = "Arial", fontSize = "14px", fontStyle = "normal", fontWeight = "normal" } = style
      ctx.font = `${fontStyle} ${fontWeight} ${fontSize} ${fontFamily}`
      const metrics = ctx.measureText(txt)
      const width = Math.max(metrics.width, metrics.actualBoundingBoxLeft - metrics.actualBoundingBoxRight)
      const height = metrics.actualBoundingBoxAscent - metrics.actualBoundingBoxDescent
      return [width, height]
    }
  }
})
</script>

<style lang="scss" scoped>
.position-wrap {
  position: relative;
  display: flex;
  overflow: visible;
  z-index: 999;
  user-select: none;
}
path {
  cursor: pointer;
}
path:hover {
  fill: #e3e3e3;
}
.svg-text {
  pointer-events: none;
  cursor: pointer;
  font-size: 14px;
  //font-size: 18px;
}
.w56 {
  width: 56px;
  height: 56px;
  line-height: 56px;
}
.site-selects .item {
  margin: 0 2px;
}
.site-selects .item:first-child {
  margin-left: 0;
}
.site-selects .item:last-child {
  margin-right: 0;
}
.site-select {
  background: #f3f3f3;
  border-radius: 4px;
  margin: 2px 0;
  text-align: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.8);
  &:hover {
    background-color: #ebebeb;
  }
  &:active {
    background-color: rgba(0, 0, 0, 0.12);
  }
}
.site-settings {
  position: absolute;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  z-index: 2;
  border: 1px solid #e9e9e9;
  background-color: #fff;
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
}
.mb6 {
  margin-bottom: 6px;
}
.site-nums {
  flex-wrap: wrap;
  justify-content: space-around;
}
.site-nums .site-select {
  width: calc(25% - 4px);
  height: 26px;
}
/**
对齐方式样式
 */
.align-style-wrap {
  width: 80px;
  height: 80px;
  margin-right: 6px;
}
.align-style-ul {
  width: 100%;
  height: 100%;
  box-shadow: 1px 1px 0 0 #e9e9e9 inset, -1px -1px 0 0 #e9e9e9 inset;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
}

.align-style-ul .item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  margin: 6px;
  cursor: pointer;
  .inner {
    width: 4px;
    height: 4px;
    background: #86909c;
    transform: scale(0.5);
  }
}
.align-style-ul .item:hover {
  border-radius: 4px;
  opacity: 0.3;
  background: var(--themeColor);
  .inner {
    background: var(--themeColor);
  }
}
.align-style-ul .item.selected {
  border-radius: 4px;
  opacity: 1;
  background: var(--themeColor);
  .inner {
    background: var(--themeColor);
  }
}
/**
对齐方式样式
 */
.position-select {
  background: #f3f3f3;
  border-radius: 4px;
  height: 32px;
  padding: 0 13px;
  box-sizing: border-box;
  cursor: pointer;
  .icon {
    width: 20px;
    pointer-events: none;
    transition: transform 0.3s;
    transform-origin: center center;
    &.rotate180 {
      transform: rotate(180deg);
    }
  }
  .text-right {
    font-size: 16px;
    width: 16px;
    text-align: right;
  }
}
.position-selects-wrap {
  //position: absolute;
  //margin-top: 4px;
  //top:32px;
  width: 228px;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  border: 1px solid #dee0e3;
  padding: 4px 0;
  z-index: 9999;
  //width: 100%;
  background-color: #fff;
  .position-select-item {
    padding: 0 12px;
    height: 38px;
    line-height: 38px;
    box-sizing: border-box;
    width: 100%;
    cursor: pointer;
    .icon {
      margin-right: 9px;
    }
    &:hover {
      background-color: #f0f2f7;
    }
  }
  .icon-img {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
  }
  .icon-img.icon-absolute {
    background-image: url("../../../assets/images/absolute.png");
  }
  .icon-img.icon-fixed {
    background-image: url("../../../assets/images/fixed.png");
  }
}
.position-info {
  position: relative;
  padding: 12px 12px 12px 24px;
  box-sizing: border-box;
  border-top: 1px solid #e8e8e8;
  &:before {
    position: absolute;
    top: 12px;
    bottom: 12px;
    left: 11px;
    width: 2px;
    content: "";
    background-color: rgba(43, 103, 255, 0.5);
  }
}
.position-select-set {
  position: relative;
}
.position-select-dropdown {
  width: 100%;
}
</style>
